export default "__VITE_ASSET__C$h$ASag__"